import React, { useEffect, useState, lazy } from 'react';
import { ShieldCheck, PenLine, Sparkles, ArrowRight } from 'lucide-react';
const URL_BASIC = 'https://mentecheck.librosdigitales.pro/cart/46849998749835:1';
const URL_BUNDLE = 'https://mentecheck.librosdigitales.pro/cart/46850256437387:1';
type Option = 'basic' | 'bundle';
export function Checkout() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  const [selected, setSelected] = useState<Option>('basic');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 14 * 60 + 50);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Listen for external selection requests (e.g. from HistoriasPunoYLetra CTA)
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as Option;
      if (detail === 'basic' || detail === 'bundle') {
        setSelected(detail);
      }
    };
    window.addEventListener('select-checkout-option', handler as EventListener);
    return () => window.removeEventListener('select-checkout-option', handler as EventListener);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const isBasic = selected === 'basic';
  const isBundle = selected === 'bundle';
  const activeUrl = isBundle ? URL_BUNDLE : URL_BASIC;
  const ctaText = isBundle ? 'SÍ, QUIERO EL PACK COMPLETO →' : 'SÍ, QUIERO MENTE ACTIVA →';
  const handleCtaClick = () => {
    window.location.href = activeUrl;
  };
  return <section id="checkout" className="py-4 md:py-20 px-3 md:px-4 bg-white scroll-mt-2" data-id="element-37">
      <div className="max-w-3xl mx-auto text-center" data-id="element-38">
        <div className="bg-red-50 border border-red-200 rounded-full px-3 md:px-6 py-1 md:py-2 inline-flex items-center gap-2 mb-3 md:mb-8" data-id="element-39">
          <span className="relative flex h-2.5 w-2.5 md:h-3 md:w-3" data-id="element-40">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-41"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 md:h-3 md:w-3 bg-red-500" data-id="element-42"></span>
          </span>
          <span className="text-red-600 font-bold tracking-widest text-xs md:text-base" data-id="element-43">
            EXPIRA EN: {formatTime(timeLeft)}
          </span>
        </div>

        <div className="bg-[#EFE4CC] border-2 border-teal-500/50 rounded-2xl md:rounded-3xl p-3 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-44">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-teal-500 to-transparent" data-id="element-45"></div>

          <h2 className="text-xl md:text-4xl font-extrabold text-slate-900 mb-1 md:mb-2" data-id="element-46">
            Elegí tu acceso
          </h2>
          <p className="text-[11px] md:text-base text-slate-600 mb-3 md:mb-6" data-id="element-47">
            Todas las opciones incluyen los 6 tomos + 4 bonos
          </p>

          {/* Product 1: MENTE ACTIVA */}
          <button type="button" onClick={() => setSelected('basic')} className="block w-full mb-3 md:mb-4 text-left group" data-id="element-48">
            <div className={`bg-white rounded-xl md:rounded-2xl p-3 md:p-6 shadow-md hover:shadow-xl transition-all relative border-2 ${isBasic ? 'border-teal-500' : 'border-slate-200'}`} data-id="element-49">
              {isBasic && <div className="absolute -top-2.5 left-4 md:-top-3 md:left-6 bg-teal-600 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full tracking-wide" data-id="element-50">
                  ✓ SELECCIONADO
                </div>}

              <div className="flex items-center gap-2 md:gap-4" data-id="element-51">
                <div className={`shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center bg-white ${isBasic ? 'border-teal-600' : 'border-slate-300'}`} data-id="element-52">
                  {isBasic && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-teal-600" data-id="element-53"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-54">
                  <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-55">
                    <span className="text-base md:text-xl" data-id="element-56">📘</span>
                    <h3 className="text-sm md:text-xl font-extrabold text-slate-900 truncate" data-id="element-57">
                      MENTE ACTIVA
                    </h3>
                  </div>
                  <p className="text-[10px] md:text-sm text-slate-600 leading-tight md:leading-snug" data-id="element-58">
                    6 Tomos + 4 Bonos · 48 fichas · Sistema completo
                  </p>
                </div>

                <div className="shrink-0 text-right" data-id="element-59">
                  <p className="text-[10px] md:text-xs text-slate-400 line-through leading-none mb-0.5 md:mb-1" data-id="element-60">
                    $49.900
                  </p>
                  <p className="text-base md:text-2xl font-black text-teal-700 leading-none" data-id="element-61">
                    $19.990
                  </p>
                  <p className="text-[9px] md:text-[10px] text-slate-500 mt-0.5 md:mt-1" data-id="element-62">
                    ARS
                  </p>
                </div>
              </div>
            </div>
          </button>

          {/* Product 2: BUNDLE — MENTE ACTIVA + HISTORIAS */}
          <button type="button" onClick={() => setSelected('bundle')} className="block w-full mb-3 md:mb-6 text-left group" data-id="element-63">
            <div className={`bg-white rounded-xl md:rounded-2xl p-3 md:p-6 shadow-md hover:shadow-xl transition-all relative border-2 ${isBundle ? 'border-orange-500 ring-2 ring-orange-200' : 'border-slate-200'}`} data-id="element-64">
              <div className="absolute -top-2.5 right-4 md:-top-3 md:right-6 bg-orange-500 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full tracking-wide flex items-center gap-1" data-id="element-65">
                <Sparkles className="w-3 h-3" data-id="element-66" /> MÁS COMPLETO
              </div>

              {isBundle && <div className="absolute -top-2.5 left-4 md:-top-3 md:left-6 bg-orange-600 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full tracking-wide" data-id="element-67">
                  ✓ SELECCIONADO
                </div>}

              <div className="flex items-center gap-2 md:gap-4" data-id="element-68">
                <div className={`shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center bg-white ${isBundle ? 'border-orange-500' : 'border-slate-300'}`} data-id="element-69">
                  {isBundle && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-orange-500" data-id="element-70"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-71">
                  <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-72">
                    <span className="text-base md:text-xl" data-id="element-73">📘🖋️</span>
                    <h3 className="text-sm md:text-xl font-extrabold text-slate-900 leading-tight" data-id="element-74">
                      MENTE ACTIVA + Historias de mi puño y letra
                    </h3>
                  </div>
                  <p className="text-[10px] md:text-sm text-slate-600 leading-tight md:leading-snug" data-id="element-75">
                    Todo lo anterior + Historias de mi puño y letra
                  </p>
                </div>

                <div className="shrink-0 text-right" data-id="element-76">
                  <p className="text-[10px] md:text-xs text-slate-400 line-through leading-none mb-0.5 md:mb-1" data-id="element-77">
                    $76.890
                  </p>
                  <p className="text-base md:text-2xl font-black text-orange-600 leading-none" data-id="element-78">
                    $29.990
                  </p>
                  <p className="text-[9px] md:text-[10px] text-slate-500 mt-0.5 md:mt-1" data-id="element-79">
                    ARS
                  </p>
                </div>
              </div>
            </div>
          </button>

          {/* Brief description for "Historias de mi puño y letra" */}
          <div className="bg-orange-50 border border-orange-200 rounded-xl md:rounded-2xl p-3 md:p-6 mb-4 md:mb-8 text-left" data-id="element-80">
            <div className="flex items-center gap-2 mb-2 md:mb-3" data-id="element-81">
              <PenLine className="w-4 h-4 md:w-5 md:h-5 text-orange-600 shrink-0" data-id="element-82" />
              <h4 className="text-sm md:text-lg font-bold text-slate-900" data-id="element-83">
                ¿Qué es "Historias de mi puño y letra"?
              </h4>
            </div>
            <p className="text-[11px] md:text-sm text-slate-700 leading-snug mb-2 md:mb-3" data-id="element-84">
              Un cuadernillo guiado para que tu papá, mamá, abuelo o abuela
              escriba su historia de vida con su puño y letra. Sin tecnología,
              sin apuro, sin necesidad de ayuda. Solo ellos, una lapicera y
              preguntas que despiertan recuerdos profundos.
            </p>
            <ul className="space-y-1 md:space-y-1.5 text-[11px] md:text-sm text-slate-700" data-id="element-85">
              <li className="flex items-start gap-2" data-id="element-86">
                <span className="text-orange-600 mt-0.5" data-id="element-87">✓</span>
                <span data-id="element-88">6 estaciones de vida con disparadores emocionales</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-89">
                <span className="text-orange-600 mt-0.5" data-id="element-90">✓</span>
                <span data-id="element-91">
                  Carta de dedicatoria + portada personalizada con foto
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-92">
                <span className="text-orange-600 mt-0.5" data-id="element-93">✓</span>
                <span data-id="element-94">Página "El Puente" para completar juntos en familia</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-95">
                <span className="text-orange-600 mt-0.5" data-id="element-96">✓</span>
                <span data-id="element-97">
                  El recuerdo más valioso que vas a guardar para siempre
                </span>
              </li>
            </ul>
            <p className="text-[11px] md:text-sm font-semibold text-slate-900 mt-2 md:mt-3 italic" data-id="element-98">
              No es un gasto. Es una herencia.
            </p>
          </div>

          <div className="space-y-2 md:space-y-6" data-id="element-99">
            <button type="button" onClick={handleCtaClick} className={`w-full font-bold py-3 md:py-5 px-4 md:px-8 rounded-xl text-base md:text-xl text-white transition-all duration-300 transform hover:scale-105 animate-pulse-glow shadow-lg flex items-center justify-center gap-2 ${isBundle ? 'bg-orange-500 hover:bg-orange-600' : 'bg-teal-600 hover:bg-teal-700'}`} data-id="element-100">
              {ctaText}
              <ArrowRight className="w-5 h-5 shrink-0" data-id="element-101" />
            </button>

            <a href={activeUrl} className="block w-full -mt-2 md:-mt-5" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/tZbaQPtNC24bXgJ7Jj36WR/imagen.png" alt="Pago seguro con Mercado Pago" loading="lazy" className="w-full h-auto cursor-pointer hover:scale-[1.02] transition-transform duration-300" data-id="element-103" />
            </a>

            <div className="flex flex-col items-center gap-1.5 md:gap-3 text-xs md:text-sm text-slate-600" data-id="element-104">
              <div className="flex items-center gap-1.5 md:gap-2 text-green-700 bg-green-100 px-3 md:px-4 py-1 md:py-2 rounded-full" data-id="element-105">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5" data-id="element-106" />
                <span className="font-medium text-[11px] md:text-sm" data-id="element-107">
                  Pago 100% seguro
                </span>
              </div>
              <p className="text-[10px] md:text-sm" data-id="element-108">
                Descarga inmediata en PDF · Acceso de por vida
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}